<h2 mat-dialog-title>Recherche de métadonnées (par Titre - Artiste - Album)</h2>

<div mat-dialog-content>
  <p class="review-loading" *ngIf="loading">Recherche en cours…</p>

  <p *ngIf="!loading && errorMessage">{{ errorMessage }}</p>

  <div class="spotify-candidates" *ngIf="!loading && !errorMessage && spotifyCandidates.length > 1">
    <p class="spotify-candidates-title">Plusieurs correspondances Spotify trouvées — la plus probable est présélectionnée :</p>
    <div class="spotify-candidates-list">
      <button type="button" class="spotify-candidate-card" *ngFor="let candidate of spotifyCandidates"
              [class.selected]="candidate.index === selectedCandidateIndex"
              (click)="selectCandidate(candidate.index)">
        <img *ngIf="candidate.cover" [src]="candidate.cover" class="review-thumb" alt="">
        <div class="spotify-candidate-info">
          <strong>{{ candidate.artist }} — {{ candidate.title }}</strong>
          <span>{{ candidate.album }}<ng-container *ngIf="candidate.year"> ({{ candidate.year }})</ng-container></span>
        </div>
      </button>
    </div>
  </div>

  <p *ngIf="!loading && !errorMessage && rows.length === 0">Aucune nouvelle information trouvée par rapport à ce qui est déjà renseigné.</p>

  <table class="metadata-review-table" *ngIf="!loading && rows.length > 0">
    <thead>
      <tr>
        <th></th>
        <th>Champ</th>
        <th>Valeur actuelle</th>
        <th>Proposition</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of rows" [class.unconfirmed-row]="row.unconfirmed">
        <td><mat-checkbox [(ngModel)]="row.checked"></mat-checkbox></td>
        <td>{{ row.label }}</td>
        <td>
          <img *ngIf="row.isImage && row.currentDisplay !== '—'" [src]="row.currentDisplay" class="review-thumb" alt="">
          <span *ngIf="!row.isImage || row.currentDisplay === '—'">{{ row.isImage ? '—' : row.currentDisplay }}</span>
        </td>
        <td>
          <img *ngIf="row.isImage && !row.unconfirmed && row.proposedDisplay !== '—'" [src]="row.proposedDisplay" class="review-thumb" alt="">
          <span *ngIf="!row.isImage || row.unconfirmed || row.proposedDisplay === '—'" class="unconfirmed-hint">
            {{ (row.isImage && !row.unconfirmed) ? '—' : row.proposedDisplay }}<ng-container *ngIf="row.unconfirmed"> (cocher pour vider)</ng-container>
          </span>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="review-actions-secondary" *ngIf="rows.length > 0">
    <button mat-button (click)="checkAll(true)">Tout cocher</button>
    <button mat-button (click)="checkAll(false)">Tout décocher</button>
  </div>
</div>

<div mat-dialog-actions>
  <button mat-button (click)="cancel()">Annuler</button>
  <button mat-raised-button color="primary" (click)="apply()" [disabled]="loading || rows.length === 0">Appliquer</button>
</div>
